// Широкая таблица в статье прокручивается внутри себя (см. content.css). Чтобы её можно
// было прокрутить с клавиатуры, такая таблица получает фокус и подпись для скринридера.
// Ширину сообщает ResizeObserver — после раскладки, которую браузер делает сам: чтение
// scrollWidth прямо при запуске заставляло пересчитывать раскладку всей статьи. Он же
// снимает фокус, если таблица перестала быть широкой (поворот экрана, другое окно).

let observer = null;

export default function tables() {
    if (observer) observer.disconnect();
    const items = document.querySelectorAll(".gh-content table");
    if (!("ResizeObserver" in window)) {
        items.forEach(markScrollable);
        return;
    }
    observer = new ResizeObserver((entries) => entries.forEach((entry) => markScrollable(entry.target)));
    items.forEach((table) => observer.observe(table));
}

/** Ставит или снимает фокус и подпись в зависимости от того, прокручивается ли таблица. */
function markScrollable(table) {
    // Фокус, поставленный редактором в самой статье, не трогаем — только свой.
    if (table.hasAttribute("tabindex") && !table.dataset.thScrollable) return;
    const scrollable = table.scrollWidth > table.clientWidth;
    if (scrollable === (table.dataset.thScrollable === "true")) return;
    table.dataset.thScrollable = String(scrollable);
    if (scrollable) {
        table.setAttribute("tabindex", "0");
        table.setAttribute("aria-label", "Scrollable table");
    } else {
        table.removeAttribute("tabindex");
        table.removeAttribute("aria-label");
    }
}
